import React from 'react';
import '../../styles.css';
import SubLevelSelectButton from './SubLevelSelectButton.js';
import { Grid } from '@material-ui/core';

function SubLevelSelectGrid(props) {
    var buttons = []
    const labels = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
    for (let i = 0; i < 9; i++) {
        buttons[i] = <Grid key={i} item><SubLevelSelectButton level={`${props.level}${i+1}`} number={labels[i]} /></Grid>
    }
    return (
        <Grid container spacing={10} className='levelSelectDiv'>
            {buttons}
        </Grid>
    );
}

export default SubLevelSelectGrid;
